
/*******quick search***********/
// Main search input
document.querySelector('.search-box .search-form .search-box-label').addEventListener('click', function(e) {
  document.querySelector('.search-box input[type="text"]').focus();
  e.preventDefault(); // return false equivalent
});

// Handle focusin and focusout
var searchInput = document.querySelector('.search-box input[type="text"]');
searchInput.addEventListener('focusin', function(e) {
  searchInput.parents('.search-form').parents('.search-box').classList.add('focus');
});
searchInput.addEventListener('focusout', function(e) {
  searchInput.parents('.search-form').parents('.search-box').classList.remove('focus');
});

// Handle mousedown on button
document.querySelector('.search-box button').addEventListener('mousedown', function(e) {
  this.click(); // trigger the click event on the button
});

// Live search functionality
var preLoadLoadGif = new Image();
preLoadLoadGif.src = "//siliconelovers.com/cdn/shop/t/219/assets/ajax-load.gif?v=62939699503414190391779179269";
var searchTimeoutThrottle = 500;
var searchTimeoutID = -1;
var currReqObj = null;

document.querySelector('.search-box input[type="text"]').addEventListener('keyup', function() {
  var resultsBox = document.querySelector('.search-box .results-box');
  if (!resultsBox) {
    resultsBox = document.createElement('div');
    resultsBox.classList.add('results-box');
    document.querySelector('.search-box .search-form').appendChild(resultsBox);
  }

  var inputValue = this.value;

  // Only search if the search string is longer than 2 characters, and it has changed
  if (inputValue.length > 2 && inputValue !== this.dataset.oldval) {
    this.dataset.oldval = inputValue;

    // Kill outstanding ajax request
    if (currReqObj) currReqObj.abort();

    // Kill previous search
    clearTimeout(searchTimeoutID);

    var form = this.closest('form');

    // Search term
    var term = form.querySelector('input[name="q"]').value;

    // Types
    var types = form.querySelector('input[name="type"]').value;

    // URL for full search page
    var linkURL = form.action + '?type=' + types + '&q=' + term;

    // Show loading
    resultsBox.innerHTML = '<div class="load"></div>';

    // Do the search after X milliseconds
    searchTimeoutID = setTimeout(function() {
      currReqObj = fetch(form.action + '?type=' + types + '&view=json&q=' + term, { method: 'GET' })
        .then(response => response.json())
        .then(function(data) {
          currReqObj = null;
          if (data.results_total === 0) {
            resultsBox.innerHTML = '<div class="note">' + "Translation missing: en.layout.live_search.no_results" + '</div>';
          } else {
            resultsBox.innerHTML = ''; // Clear previous results
            data.results.forEach(function(item) {
              if (item.hidden) return;

              var row = document.createElement('a');
              row.setAttribute('href', item.url);
              
              var img = document.createElement('div');
              img.classList.add('img');
              var image = document.createElement('img');
              image.setAttribute('src', item.thumb);
              img.appendChild(image);
              
              row.appendChild(img);
              row.appendChild(document.createTextNode(item.title));
              resultsBox.appendChild(row);
            });

            var seeAllLink = document.createElement('a');
            seeAllLink.setAttribute('href', linkURL);
            seeAllLink.classList.add('note');
            seeAllLink.textContent = "Translation missing: en.layout.live_search.see_all" + ' (' + data.results_total + ')';
            resultsBox.appendChild(seeAllLink);
          }
        });
    }, searchTimeoutThrottle);
  } else if (inputValue.length <= 2) {
    // If input is deleted, clear results
    resultsBox.innerHTML = '';
  }
});

// Show existing results on focusin
searchInput.addEventListener('focusin', function() {
  document.querySelector('.search-box .results-box').style.display = 'block';
});

// Show results on click of the input field
searchInput.addEventListener('click', function(e) {
  document.querySelector('.search-box .results-box').style.display = 'block';
  e.preventDefault(); // Prevent body from receiving the click event
});

// Hide results when clicking anywhere outside the search box
document.body.addEventListener('click', function () {
  const resultsBox = document.querySelector('.search-box .results-box');
  if (resultsBox) resultsBox.style.display = 'none';
});

// Search form submission logic
document.querySelectorAll('.search-form, #search-form, .mobile-search').forEach(function(form) {
  form.addEventListener('submit', function(e) {
    var val = form.querySelector('input[name="q"]').value;
    if (val.length > 0) {
      e.preventDefault();
      var term = val;
      var type = form.querySelector('input[name="type"]').value || '';
      var linkURL = form.action + '?type=' + type + '&q=' + term;
      window.location = linkURL;
    }
  });
});
